import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions, CommentEntity, CommentStatus } from './index';

export type CommentCreateData = { id: string };

export type CommentCreateResponse = CommentCreateData


export interface CommentCreateBody {
  text?: string | null;
  businessId?: string | null;
  categoryId?: string | null;
  subCategoryId?: string | null;
  articleId?: string | null;
  postId?: string | null;
  fileIds?: string[];
  status?: CommentStatus;
  entity?: CommentEntity,
}
export interface CommentCreateParams {
  body: CommentCreateBody;
  parentId?: string;
}

export const commentCreate = (payload: CommentCreateParams): Action<CommentCreateParams> => ({
  type: actions.commentCreateTrigger.toString(),
  payload,
});

export const commentCreateClear = (): Action => ({
  type: actions.commentCreateClear.toString(),
});

export const commentCreateErrorClear = (): Action => ({
  type: actions.commentCreateErrorReset?.toString(),
});

export function* commentCreateRequestSaga({ payload }: Action<CommentCreateBody>) {
  ({ payload })
  yield put({
    type: actions.commentCreateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.commentCreateError.toString(),
      payload: {
        message: 'CommentCreate: Parameters not passed.',
      },
    });

    return;
  }

  const { body, parentId } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}comments${parentId ? `/${parentId}` : ''}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<CommentCreateData, CommentCreateResponse>(
    response,
    actions.commentCreateSuccess.toString(),
    actions.commentCreateError.toString(),
    false,
    (commentCreateData) => commentCreateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.commentCreateTrigger.toString(),
    defaultProcessingSaga(
      commentCreateRequestSaga,
      {
        error: actions.commentCreateError.toString(),
        locationCancel: actions.commentCreateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.commentCreateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.commentCreateClear.toString(),
    // });
  });

  yield takeLatest(actions.commentCreateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.commentCreateErrorReset.toString(),
    });
  });
}
